import React from 'react'
import Hero from '../components/Consumer/Hero'
import ValueProposition from '../components/Consumer/ValueProposition'
import Features from '../components/Consumer/Features'
import Testimonials from '../components/Consumer/Testimonials'
import CTA from '../components/Consumer/CTA'
import Footer from '../components/Consumer/Footer'
import Pricing from '../components/Consumer/Pricing'
import WhatsappButton from '../components/Consumer/WhatsAppFloatingButton'


function ConsumerPage() {
  return (
    <div id="Home" className="font-lato">
    <Hero />
    <ValueProposition />
    <Features />
   {/* <Testimonials /> */}
   <Pricing/>
    <CTA />
    <Footer />
    <WhatsappButton/>
  </div>
  )
}

export default ConsumerPage
